export const sliderSettings = {
    slidesPerView: 1,
    spaceBetween: 50,
    //specifying slidesperview according to device width
    breakpoints: {
      480: {
        slidesPerView: 1,
      },
      600: {
        slidesPerView: 2,
      },
      750: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 3,
      },
    },
  };